import { WebSignupQueryParam } from '@naturalcycles/shared'

export const defaultQueryParams = [WebSignupQueryParam.flow, WebSignupQueryParam.measuringDevice]
export const defaultCbQueryParams = [WebSignupQueryParam.cbo]
